import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import IconContainer from "@/components/ui/icon-container";
import { Asterisk } from "@dreamhub/designsystem/icons";

interface Props {
  translationPrefix: string;
  answeredCount?: number;
  answeredRequiredCount?: number;
  requiredCount?: number;
  totalCount?: number;
}

const WorkflowDetailPanelFooter: React.FC<Props> = ({
  translationPrefix,
  answeredCount = 0,
  answeredRequiredCount = 0,
  requiredCount = 0,
  totalCount = 0
}) => {
  const { t } = useTranslation();
  const hasRequired = requiredCount > 0;

  return (
    <div className="px-8 py-3 flex items-center justify-between">
      <div className="flex items-center gap-4">
        {hasRequired ? (
          <>
            <Text variant="bodySecondary">
              {t(`${translationPrefix}.answered`)}
            </Text>
            <Text variant="bodySecondary">
              {answeredRequiredCount}/{requiredCount}{" "}
              {t(`${translationPrefix}.required`)}
            </Text>
            <Text variant="bodySecondary">
              {answeredCount}/{totalCount} {t(`${translationPrefix}.total`)}
            </Text>
          </>
        ) : (
          <Text variant="bodySecondary">
            {t(`${translationPrefix}.answered`)} {answeredCount}/{totalCount}
          </Text>
        )}
      </div>
      {hasRequired ? (
        <div className="flex items-center gap-1">
          <IconContainer size="5">
            <Asterisk />
          </IconContainer>
          <Text variant="bodySecondary">
            {t(`${translationPrefix}.requiredField`)}
          </Text>
        </div>
      ) : null}
    </div>
  );
};

export default WorkflowDetailPanelFooter;
